var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isPatient)?_c('LoginFormPatient'):_c('LoginFormProfessional')
}
var staticRenderFns = []

export { render, staticRenderFns }